import { Injectable } from '@angular/core';

import { ApiService, AppContext, LogService } from './../../shared';

@Injectable()
export class ApptFormService {
  status: string = '';

  // fields
  name: string = '';
  email: string = '';
  // ****
  domain: string = '';
  // ****
  company: string = '';
  position: string = '';
  telephone: string = '';
  country: string = '';
  message: string = '';

  frontError: boolean = false;
  emailError: boolean = false;
  emailErrorMessage: string = '';
  messageError: boolean = false;
  messageErrorMessage: string = '';

  nameErrorMessage: string = '';
  nameError: boolean = false;

  companyErrorMessage: string = '';
  companyError: boolean = false;

  positionErrorMessage: string = '';
  positionError: boolean = false;

  countryErrorMessage: string = '';
  countryError: boolean = false;

  telephoneErrorMessage = '';
  telephoneError = false;

  type: string = 'Contact';

  constructor(private api: ApiService, public app: AppContext, private logger: LogService) {
  }

  setType(type: string = 'Appointment') {
    this.type = type;
  }

  contact() {
    this.frontError = false;

    let toSend = {
      from: this.name,
      email: this.email,
      domain: this.domain,
      type: this.type,
      company: this.company,
      position: this.position,
      telephone: this.telephone,
      country: this.country,
      message: this.message
    };

    this.validateEmail();
    this.validateMessage();
    this.validateName();
    this.validateCompany();
    this.validatePosition();
    this.validateTelephone();
    this.validateCountry();

    if (this.status !== 'sending' && this.frontError === false) {
      this.status = 'sending';
      this.api.getApiClient().then(client => this.callContact(client, toSend));
    }
  }

  validateEmail() {
    //let EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
    let EMAIL_REGEXP = this.app.EMAIL_REGEXP;

    if (EMAIL_REGEXP.test(this.email)) {
      this.emailErrorMessage = '';
      this.emailError = false;
      this.domain = "www." + this.email.split("@")[1];
    } else if (this.email === '') {
      this.frontError = true;
      this.emailErrorMessage = 'Email required';
      this.emailError = true;
    } else {
      this.frontError = true;
      this.emailErrorMessage = 'Invalid email';
      this.emailError = true;
    }
  }

  validateMessage() {
    if (this.message !== '') {
      this.messageErrorMessage = '';
      this.messageError = false;
    } else {
      this.frontError = true;
      this.messageErrorMessage = 'Please include a message';
      this.messageError = true;
    }
  }

  validateName() {
    if (this.name !== '') {
      this.nameErrorMessage = '';
      this.nameError = false;
    } else {
      this.frontError = true;
      this.nameErrorMessage = 'Name required';
      this.nameError = true;
    }
  }

  validateCompany() {
    if (this.company !== '') {
      this.companyErrorMessage = '';
      this.companyError = false;
    } else {
      this.frontError = true;
      this.companyErrorMessage = 'Company required';
      this.companyError = true;
    }
  }

  validatePosition() {
    if (this.position !== '') {
      this.positionErrorMessage = '';
      this.positionError = false;
    } else {
      this.frontError = true;
      this.positionErrorMessage = 'Position required';
      this.positionError = true;
    }
  }

  validateTelephone() {
    if (this.telephone !== '') {
      this.telephoneErrorMessage = '';
      this.telephoneError = false;
    } else {
      this.frontError = true;
      this.telephoneErrorMessage = 'Telephone number required';
      this.telephoneError = true;
    }
  }

  validateCountry() {
    if (this.country !== '') {
      this.countryErrorMessage = '';
      this.countryError = false;
    } else {
      this.frontError = true;
      this.countryErrorMessage = 'Country required';
      this.countryError = true;
    }
  }

  numeralInputMasking(event) {
    let e = event || window.event;
    let key = event.keyCode || e.which;

    if ((key < 48 || key > 57) && key !== 37 && key !== 38
      && key !== 39 && key !== 40 && key !== 46
      && key !==  8 && key !== 35 && key !== 101 && key !== 120 && key !== 116 ) {
      e.preventDefault();
    }
  }

  callContact(apigClient: any, toSend: any) {
    this.logger.log('contact.service', 'callContact', toSend);
    let params = {};
    let body = toSend;
    let additionalParams = {
      headers: { 'Content-Type' : 'application/json' },
      queryParams: {}
    };
    try {
      apigClient.userContactPost(params, body, additionalParams)
      .then((result) => {
        this.logger.log('contact.service', 'resovlve', result);
        this.status = 'Success';
      }).catch((err) => {
        this.status = 'Unable to connect to the server. Your message is important to us. Please try again later.';
        this.api.handleError(err);
      });
    } catch (ex) {
      this.status = 'Unable to connect to the server. Your message is important to us. Please try again later.';
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/static/appt-form/appt-form.service.ts